import Inputmask from "inputmask";
import { load } from "recaptcha-v3";

let mentorForm = args => {
    return {
        testing: false, //<--make true if testing (removes error blocks)
        formStep: 0, //<--change this number to start on a specific slide [0,1,2]
        caregiverVisible: false,
        paginationVisible: true, //<-- turn on/off pagination menu
        showLegal: false,
        contextPath: args.contextPath,
        errorPageLink: args.errorPageLink,
        successPageLink: args.successPageLink,
        formElement: document.querySelector(".mentorWrap"),
        submitUrl: "/.rest/mentor/",
        baseEndPtUrl: "",
        //choose multiple queryselectors
        //discussion topics
        discussTopics: [],
        //days of the week
        daysOfTheWeek: [],
        //times of the day
        timesOfTheDay: [],
        //end choose multiple
        timeZone: "",
        howDidYouHear: "",
        //checkboxes
        voicemails: document.querySelector("[name='voicemails']"),
        sms: document.querySelector("[name='sms']"),
        dmw: document.querySelector("[name='dmw']"),
        formData: {
            // Default schema
            indication: args.indication.toUpperCase(),
            patientOrCaregiver: "",
            userDOB: "",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            prescriptionStatus: "",
            discussionTopics: [],
            language: null,
            daysOfTheWeek: [],
            timesOfTheDay: [],
            timeZone: "",
            howDidYouHear: "",
            voicemails: false,
            sms: false,
            dmw: false,
            confirm: false
        },
        env() {
            const winOrigin = window.location.origin;
            this.baseEndPtUrl = this.contextPath ? winOrigin + this.contextPath : (this.baseEndPtUrl = winOrigin);
        },
        init() {
            this.env();
            this.isStep(0);
            this.toggleTesting();
            this.ambotLimit();

            Inputmask().mask(document.querySelectorAll("input"));
        },
        canSubmit() {
            if (this.formStep === 2) {
                if (this.formData.daysOfTheWeek.length > 0 && this.formData.timesOfTheDay.length > 0 && this.formData.timeZone && this.formData.howDidYouHear && this.formData.confirm) {
                    return true;
                }
            }
            return false;
        },
        ambotLimit() {
            let limits = document.querySelectorAll("[data-limit]");
            limits.forEach(limit => {
                limit.onclick = () => {
                    let max = limit.dataset.limit;
                    let checkbox = limit.querySelectorAll('input[type="checkbox"]:checked');
                    return max < checkbox.length ? false : true;
                };
            });
        },
        toggleTesting() {
            let isTesting = this.formElement.dataset.testing;

            switch (isTesting) {
                case "testing":
                    this.testing = true;
                    break;
                case "not-testing":
                    this.testing = false;
                    break;
            }
        },
        showTextLegal(e) {
            e.preventDefault;
            this.showLegal = !this.showLegal;
        },
        nextStep(e) {
            switch (this.formStep) {
                case 0:
                    if (this.slideOneValidation(e)) {
                        this.formStep = this.formStep + 1;
                    }
                    break;
                case 1:
                    if (this.slideTwoValidation(e)) {
                        this.formStep = this.formStep + 1;
                    }
                    break;
            }
        },
        formDataBuildChecked(el) {
            document.querySelectorAll(el).forEach(topic => {
                let topicInput = topic.querySelector("input");
                if (topicInput.checked) {
                    this.formData[topicInput.name] = topicInput.value;
                } else {
                    this.formData[topicInput.name] = "";
                }
            });
        },
        formDataBuildSelected(el) {
            let text = el.innerText;
            let dropdownItems = el.parentElement.querySelectorAll(".dropdown-item");
            dropdownItems.forEach(item => {
                if (text == item.innerText) {
                    this.formData[item.dataset.name] = item.dataset.value;
                }
            });
        },
        submit() {
            if (this.slideThreeValidation()) {
                let body = new URLSearchParams();
                let url = this.baseEndPtUrl + this.submitUrl;
                var recaptchaV3String = $("button[name='recaptcha']").val();
                var recaptchaV3Boolean = recaptchaV3String === "true";

                if (recaptchaV3Boolean) {
                    const recaptchaID = document.querySelector(".submit").dataset.sitekey;
                    load(recaptchaID).then(recaptcha => {
                        recaptcha.execute("submit").then(token => {
                            this.postData(token, recaptchaV3Boolean, body, url);
                        });
                    });
                } else {
                    let token = false;
                    this.postData(token, recaptchaV3Boolean, body, url);
                }
            }
        },
        async postData(token, recaptcha, body, url) {
            this.formDataBuildSelected(this.$refs.timezone);
            this.formDataBuildSelected(this.$refs.hearAbout);
            //remove cargiverOf if PATIENT
            if (this.formData.patientOrCaregiver == "PATIENT" && this.formData.caregiverOf) {
                delete this.formData.caregiverOf;
            }
            //add cargiverOf ADULT if CRSWNP and caregiver
            if (this.formData.patientOrCaregiver == "CAREGIVER" && this.formData.indication == "CRSWNP") {
                this.formData.caregiverOf = "ADULT";
            }
            //remove language if no preference
            if (this.formData.language == "" || this.formData.language == null) {
                delete this.formData.language;
            }
            //add multiples to payload seperately
            for (const [key, value] of Object.entries(this.formData)) {
                if (Array.isArray(value)) {
                    value.forEach(v => {
                        body.append(key, v);
                    });
                } else {
                    body.append(key, value);
                }
            }
            if (recaptcha) {
                body.append("g-recaptcha-response", token);
            }
            let response;
            try {
                response = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    body: body
                });
            } catch (error) {
                window.location.replace(this.errorPageLink);
            }

            if (response.ok) {
                const res = await response.text();
                window.location.replace(this.successPageLink);
                return JSON.parse(res);
            }

            return false;
        },
        prevStep() {
            this.formStep = this.formStep - 1;
        },
        isStep(step) {
            return this.formStep === step;
        },
        hideCaregiver() {
            this.caregiverVisible = false;
        },
        openSelect(e) {
            let inner = e.target.nextElementSibling;
            let parent = e.target.parentElement;
            inner.classList.toggle("hidden");
            inner.classList.toggle("open");
            parent.classList.toggle("open");

            if (parent.classList.contains("open") && parent.classList.contains("fit-content")) {
                e.target.style.maxWidth = "297px";
            } else {
                e.target.style = "";
            }
            if (e.target.classList.contains("timezone")) {
                this.checkTimezone();
            } else {
                this.checkHearAbout();
            }
        },
        isRequired(input) {
            if (input.value === "") {
                return false;
            } else {
                return true;
            }
        },
        isEmailValid(email) {
            return String(email.value)
                .toLowerCase()
                .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        },
        isBitrhdayValid(birthday) {
            if (!String(birthday.value).match(/^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/)) {
                return false;
            }
            let birthdaySplit = birthday.value.split("/");
            let year = birthdaySplit[2];
            //current date
            let currentDate = new Date();
            let ageRestriction = 18; //<-- change this to change age restriction
            //check year against current year
            if (currentDate.getFullYear() - year < ageRestriction) {
                return false;
            }
            return true;
        },
        isPhoneValid(phone) {
            if (phone.value.length < 10) {
                return false;
            } else {
                return true;
            }
        },
        isGroupValid(groups) {
            let options = [...groups];

            let isChecked = options.some(option => {
                return option.querySelector("input").checked;
            });
            return isChecked;
        },
        isChecked(input) {
            if (input.checked) {
                return true;
            } else {
                return false;
            }
        },
        isPatient() {
            let value = false;
            let patient = document.querySelector("#patient");
            let caregiver = document.querySelector("#caregiver");

            if (patient.checked || (!patient.checked && !caregiver.checked)) {
                value = true;
                this.formData.patientOrCaregiver = patient.value;
            } else if (caregiver.checked) {
                value = false;
                this.formData.patientOrCaregiver = caregiver.value;
            }

            return value;
        },
        showSuccess(input) {
            const formField = input.parentElement;
            formField.classList.remove("error");
            formField.classList.add("success");
            const error = formField.querySelector("small");
            error.classList.remove("show-error");
            error.textContent = "";
        },
        showError(input, message) {
            const formField = input.parentElement;
            formField.classList.add("error");
            formField.classList.remove("success");
            const error = formField.querySelector("small");
            error.classList.add("show-error");
            error.textContent = message;
        },
        checkBirthday() {
            let birthday = this.$refs.birthYear;
            let valid = false;
            if (this.isBitrhdayValid(birthday)) {
                this.showSuccess(birthday);
                valid = true;
            } else {
                this.showError(birthday, "Please enter a valid date.");
            }

            return valid;
        },
        checkPatientAge() {
            let patientAge = this.$refs.patientAge.querySelectorAll(".radio");
            let valid = false;
            let patient = this.isPatient();

            if (this.isGroupValid(patientAge) || patient) {
                this.showSuccess(patientAge[0]);
                valid = true;
                patientAge.forEach(p => {
                    if (p.querySelector("input").checked) {
                        this.formData.caregiverOf = p.querySelector("input").value;
                    }
                });
            } else {
                this.showError(patientAge[0], "Please select an answer.");
            }

            return valid;
        },
        checkFirstName() {
            let firstname = this.$refs.firstName;
            let valid = false;
            if (this.isRequired(firstname)) {
                this.showSuccess(firstname);
                valid = true;
            } else {
                if (this.caregiverVisible || this.checkDataIndication("CRSWNP") || this.checkDataIndication("ASTHMA")) {
                    this.showError(firstname, "Please provide a first name.");
                } else {
                    this.showError(firstname, "Please provide your first name.");
                }
            }

            return valid;
        },
        checkLastName() {
            let lastname = this.$refs.lastName;
            let valid = false;
            if (this.isRequired(lastname)) {
                this.showSuccess(lastname);
                valid = true;
            } else {
                if (this.caregiverVisible || this.checkDataIndication("CRSWNP") || this.checkDataIndication("ASTHMA")) {
                    this.showError(lastname, "Please provide a last name.");
                } else {
                    this.showError(lastname, "Please provide your last name.");
                }
            }

            return valid;
        },
        checkEmail() {
            let email = this.$refs.email;
            let valid = false;
            if (this.isEmailValid(email)) {
                this.showSuccess(email);
                valid = true;
            } else {
                this.showError(email, "Please provide a valid email address.");
            }

            return valid;
        },
        checkPhone() {
            let phone = this.$refs.phone;
            let valid = false;
            if (this.isPhoneValid(phone)) {
                this.showSuccess(phone);
                valid = true;
            } else {
                this.showError(phone, "Please provide a 10-digit phone number. (ex. XXX-XXX-XXXX)");
            }
            Inputmask({ mask: "999-999-9999", placeholder: "XXX-XXX-XXXX" }).mask(phone);
            return valid;
        },
        checkPrescription() {
            let prescription = this.$refs.prescription.querySelectorAll(".radio");
            let valid = false;
            if (this.isGroupValid(prescription)) {
                this.showSuccess(prescription[0]);
                valid = true;
            } else {
                this.showError(prescription[0], "Please select an answer.");
            }
            return valid;
        },
        checkTopics() {
            let topics = this.$refs.topics.querySelectorAll(".chkLabel");
            let valid = false;
            if (this.isGroupValid(topics)) {
                this.showSuccess(topics[0]);
                valid = true;
            } else {
                this.showError(topics[0], "Please select an answer.");
            }
            return valid;
        },
        checkLanguages() {
            let languages = this.$refs.language.querySelectorAll(".radio");
            let valid = false;
            if (this.isGroupValid(languages)) {
                this.showSuccess(languages[0]);
                valid = true;
            } else {
                this.showError(languages[0], "Please select an answer.");
            }
            return valid;
        },
        checkDays() {
            let days = this.$refs.days.querySelectorAll(".chkLabel");
            let valid = false;
            if (this.isGroupValid(days)) {
                this.showSuccess(days[0]);
                valid = true;
            } else {
                this.showError(days[0], "Please select an answer.");
            }

            return valid;
        },
        checkTime() {
            let time = this.$refs.time.querySelectorAll(".chkLabel");
            let valid = false;
            if (this.isGroupValid(time)) {
                this.showSuccess(time[0]);
                valid = true;
            } else {
                this.showError(time[0], "Please select an answer.");
            }

            return valid;
        },
        checkTimezone() {
            let timezone = this.$refs.timezone;
            let valid = false;
            if (timezone.classList.contains("selected")) {
                this.showSuccess(timezone);
                valid = true;
            }

            return valid;
        },
        checkHearAbout() {
            let hearAbout = this.$refs.hearAbout;
            let valid = false;
            if (hearAbout.classList.contains("selected")) {
                this.showSuccess(hearAbout);
                valid = true;
            }

            return valid;
        },
        checkConfirmation() {
            let confirmation = this.$refs.confirmation;
            let valid = false;
            if (this.isChecked(confirmation.querySelector("input"))) {
                this.showSuccess(confirmation);
                valid = true;
            } else {
                this.showError(confirmation, "This is a required field.");
            }

            if (valid) {
                if (!this.checkTimezone()) {
                    let timezone = this.$refs.timezone;
                    this.showError(timezone, "Please select an answer.");
                }
                if (!this.checkHearAbout()) {
                    let hearAbout = this.$refs.hearAbout;
                    this.showError(hearAbout, "Please select an answer.");
                }
            }

            return valid;
        },
        checkDataIndication(indication) {
            return this.formData.indication === indication;
        },
        slideOneValidation(e) {
            e.preventDefault();
            let isBirthyearValid = this.checkBirthday();
            let isPatientAgeValid = this.checkDataIndication("CRSWNP") && this.caregiverVisible ? true : this.checkPatientAge();
            let isFirstNameValid = this.checkFirstName();
            let isLastNameValid = this.checkLastName();
            let isEmailValid = this.checkEmail();
            let isPhoneValid = this.checkPhone();

            //total is valid
            let slideOneValid = isBirthyearValid && isPatientAgeValid && isFirstNameValid && isLastNameValid && isEmailValid && isPhoneValid;

            if (!this.testing) {
                return slideOneValid;
            } else {
                return true;
            }
        },
        slideTwoValidation(e) {
            e.preventDefault();
            //check using utilities
            let isPrescriptionValid = this.checkPrescription();
            let isTopicsValid = this.checkTopics();
            let isLanguesValid = this.checkDataIndication("CRSWNP") ? true : this.checkLanguages();
            //total is valid
            let slideTwoValid = isPrescriptionValid && isTopicsValid && isLanguesValid;

            if (!this.testing) {
                return slideTwoValid;
            } else {
                return true;
            }
        },
        slideThreeValidation() {
            //check using utilities
            let isDaysValid = this.checkDays();
            let isTimeValid = this.checkTime();
            let isTimezoneValid = this.checkTimezone();
            let isHearAboutValid = this.checkHearAbout();
            let isConfirmationValid = this.checkConfirmation();

            let slideThreeValid = isDaysValid && isTimeValid && isTimezoneValid && isHearAboutValid && isConfirmationValid;

            if (!this.testing) {
                return slideThreeValid;
            } else {
                return true;
            }
        }
    };
};

//putting mentorlogic in window
window.mentorForm = mentorForm;
